module.exports = __webpack_public_path__ + "static/media/pres__facture.241b85cb.jpg";